import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const LegalDeadlinesCard = ({ formData, setFormData }) => (
  <Card>
    <CardHeader>
      <CardTitle>Prazos Legais</CardTitle>
      <CardDescription>
        Configure os prazos de acordo com a Lei 93/2021
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div>
          <Label htmlFor="acknowledgment_days">Confirmação de Receção (dias)</Label>
          <Input
            id="acknowledgment_days"
            type="number"
            min="1"
            max="30"
            value={formData.acknowledgment_days}
            onChange={(e) => setFormData(prev => ({ ...prev, acknowledgment_days: parseInt(e.target.value) }))}
          />
          <p className="text-xs text-slate-500 mt-1">Lei: 7 dias úteis</p>
        </div>
        <div>
          <Label htmlFor="feedback_days">Feedback (dias)</Label>
          <Input
            id="feedback_days"
            type="number"
            min="1"
            max="180"
            value={formData.feedback_days}
            onChange={(e) => setFormData(prev => ({ ...prev, feedback_days: parseInt(e.target.value) }))}
          />
          <p className="text-xs text-slate-500 mt-1">Lei: 3 meses (90 dias)</p>
        </div>
        <div>
          <Label htmlFor="retention_years">Retenção (anos)</Label>
          <Input
            id="retention_years"
            type="number"
            min="1"
            max="10"
            value={formData.retention_years}
            onChange={(e) => setFormData(prev => ({ ...prev, retention_years: parseInt(e.target.value) }))}
          />
          <p className="text-xs text-slate-500 mt-1">Lei: 5 anos</p>
        </div>
      </div>
    </CardContent>
  </Card>
);
